import React, { useRef, useEffect, useState, useContext, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import api from '../api/api';
import { PermissaoLoader } from "./PermissaoLoader";
import { AuthContext } from '../contexts/AuthContext';
import moment from 'moment';

export const TabelaAvaliacao = ({ turmaId }) => {
    const toast = useRef(null);
    const [avaliacoes, setAvaliacoes] = useState([]); // Agora armazena diretamente os DTOs de Avaliação
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { permissoes } = useContext(AuthContext);

    // ESTADOS PARA PAGINAÇÃO
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rows, setRows] = useState(20);

    const getAvaliacoes = useCallback(async (page = 0, size = 20) => {
        if (!turmaId) return; 

        setIsLoading(true);
        try {
            const response = await api.get(`avaliacao/turma/${turmaId}`);
            
            // Aceita tanto o formato Page (response.data.content) quanto List direto (response.data)
            const dados = response.data.content || response.data || [];
            
            setAvaliacoes(dados);
            setTotalRecords(response.data.totalElements || dados.length);
        } catch (error) {
            console.error("Erro ao carregar avaliações:", error);
            // Trata o 404 (Not Found) enviado pelo Spring quando a lista está vazia
            if (error.response && error.response.status === 404) {
                setAvaliacoes([]);
                setTotalRecords(0);
            }
        }
        setIsLoading(false);
    }, [turmaId]);

    const onPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        getAvaliacoes(event.page, event.rows);
    };

    useEffect(() => {
        getAvaliacoes(0, rows);
        setFirst(0);
    }, [turmaId, getAvaliacoes]);

    const dataBodyTemplate = (rowData) => {
        return <span>{rowData.data ? moment(rowData.data).format('DD/MM/YYYY') : '-'}</span>;
    };

    const periodoBodyTemplate = (rowData) => {
        // Trata se o PeriodoLetivo vier como objeto/enum ou string literal
        const periodo = rowData.periodoLetivo?.name || rowData.periodoLetivo;
        const mapeamento = {
            'B_01': '01 Bimestre', 'B_02': '02 Bimestre', 'B_03': '03 Bimestre', 'B_04': '04 Bimestre',
            'T_01': '01 Trimestre', 'T_02': '02 Trimestre', 'T_03': '03 Trimestre'
        };
        return <span>{mapeamento[periodo] || rowData.periodoDescricao || periodo || "-"}</span>;
    };

    const header = (
      <div className="p-grid p-col-12 p-m-0 p-p-0">
        <div className="p-col">
          <h2 className="p-my-0">Avaliações da Turma</h2>
        </div>
        <div className="p-grid p-dir-rev p-col">
          <div className="p-m-2">
            <PermissaoLoader
              rota="avaliacao"
              acao="criar"
              onClick={() =>
                history.push({
                  pathname: '/avaliacao/create',
                  state: { turmaId: turmaId },
                })
              }
            />
          </div>
        </div>
      </div>
    );

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            
            <div className="card p-col-12 datatable-responsive-demo">
                <DataTable 
                    value={avaliacoes} 
                    header={header}
                    loading={isLoading}
                    lazy
                    paginator 
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    emptyMessage="Nenhuma avaliação lançada para esta turma."
                    className="p-datatable-responsive-demo"
                    dataKey="id"
                >
                    {/* ID da Avaliação */}
                    <Column field="id" header="ID" sortable style={{ width: '80px' }} />
                    
                    {/* Período Letivo */}
                    <Column field="periodoLetivo" header="Período" body={periodoBodyTemplate} sortable />
                    
                    {/* Tipo da Avaliação */}
                    <Column field="tipo.nome" header="Tipo" body={(rowData) => (
                        <span>{rowData.tipo?.nome || rowData.nomeTipoExibicao || "-"}</span>
                    )} />

                    {/* Data da Avaliação */}
                    <Column field="data" header="Data" body={dataBodyTemplate} sortable />

                    {/* Nota Máxima da Avaliação */}
                    <Column field="notaTotal" header="Nota Máxima" sortable />
                    
                    {/* Botão de Ação para editar a avaliação selecionada */}
                    <Column header="Ações" body={(rowData) => (
                        <Button 
                            icon="pi pi-pencil" 
                            className="p-button-rounded p-button-text p-button-info" 
                            onClick={() => history.push({
                                pathname: `/avaliacao/edit/${rowData.id}`,
                                state: { turmaId: turmaId }
                            })}
                            tooltip="Editar Avaliação"
                        />
                    )} />
                </DataTable>
            </div>
        </div>
    );
}